import Link from "./Link";
import Heading from "./Heading";
import Paragraph from "./Paragraph";
import UlList from "./UlList";
import OlList from "./OlList";
import Styled from "./Styled";

export { Link, Heading, Paragraph, UlList, OlList, Styled };
